function getToastContainer() {
  let container = document.getElementById('app-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'app-toast-container';
    container.className = 'toast-container position-fixed top-0 end-0 p-3';
    document.body.appendChild(container);
  }
  return container;
}

function buildToastElement(message, options) {
  const title = options.title ? String(options.title) : '';
  const variant = options.variant ? String(options.variant) : 'primary';
  const textClass = variant === 'light' ? 'text-dark' : 'text-white';

  const toastEl = document.createElement('div');
  toastEl.className = `toast align-items-center text-bg-${variant} border-0 ${textClass}`;
  toastEl.setAttribute('role', 'alert');
  toastEl.setAttribute('aria-live', 'assertive');
  toastEl.setAttribute('aria-atomic', 'true');

  const body = document.createElement('div');
  body.className = 'd-flex';

  const content = document.createElement('div');
  content.className = 'toast-body';
  content.textContent = title ? `${title} - ${message}` : String(message);

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = `btn-close ${variant === 'light' ? '' : 'btn-close-white'} me-2 m-auto`;
  closeBtn.setAttribute('data-bs-dismiss', 'toast');
  closeBtn.setAttribute('aria-label', 'Close');

  body.appendChild(content);
  body.appendChild(closeBtn);
  toastEl.appendChild(body);

  return toastEl;
}

export default {
  install(app) {
    app.config.globalProperties.$bvToast = {
      toast(message, options = {}) {
        try {
          const Toast = window?.bootstrap?.Toast;
          if (!Toast) {
            console.error('Bootstrap Toast not available');
            return;
          }

          const container = getToastContainer();
          const toastEl = buildToastElement(message, options);
          container.appendChild(toastEl);

          const delay = Number.isFinite(options.autoHideDelay)
            ? options.autoHideDelay
            : 5000;

          const toast = new Toast(toastEl, {
            autohide: options.solid !== false,
            delay
          });

          toastEl.addEventListener('hidden.bs.toast', () => {
            toastEl.remove();
          });

          toast.show();
        } catch (error) {
          console.error('Toast error:', error);
        }
      }
    };
  }
};
